import React, { useCallback } from "react";
import ChoiceStepDialog from "./components/dialogs/ChoiceStepDialog";
import NewAssetStepDialog from "./components/dialogs/NewAssetStepDialog";
import SearchStepDialog from "./components/dialogs/SearchStepDialog";
import SearchResultsStepDialog from "./components/dialogs/SearchResultsStepDialog";
import { LOCATION_SNAPSHOT_ADD_ITEM_STEPS } from "./steps";

const { CHOICE, NEW, SEARCH, SEARCH_RESULTS } = LOCATION_SNAPSHOT_ADD_ITEM_STEPS;

export default function LocationSnapshotAddItemStepDialog({ open, locationName, wizard }) {
  const {
    step,
    setStep,
    handleClose,
    settings,
    activeProjects,
    loadingProjects,
    creatingAsset,
    selectedProjectId,
    setSelectedProjectId,
    quantity,
    setQuantity,
    handleCreateAsset,
    setOpenCreateProject,
    searchCode,
    setSearchCode,
    handleSearch,
    searchLoading,
    searchError,
    searchResults,
    selectingAssetId,
    handleSelectSearchAsset,
  } = wizard;

  const goToChoice = useCallback(() => setStep(CHOICE), [setStep]);
  const goToNew = useCallback(() => setStep(NEW), [setStep]);
  const goToSearch = useCallback(() => setStep(SEARCH), [setStep]);
  const openCreateProjectModal = useCallback(() => setOpenCreateProject(true), [
    setOpenCreateProject,
  ]);

  switch (step) {
    case CHOICE:
      return (
        <ChoiceStepDialog
          open={open}
          locationName={locationName}
          onClose={handleClose}
          onSearch={goToSearch}
          onNew={goToNew}
        />
      );
    case NEW:
      return (
        <NewAssetStepDialog
          open={open}
          onClose={handleClose}
          settings={settings}
          activeProjects={activeProjects}
          loadingProjects={loadingProjects}
          creatingAsset={creatingAsset}
          selectedProjectId={selectedProjectId}
          onSelectProject={setSelectedProjectId}
          onOpenCreateProject={openCreateProjectModal}
          quantity={quantity}
          onQuantityChange={setQuantity}
          onCreateItem={handleCreateAsset}
          onBack={goToChoice}
        />
      );
    case SEARCH:
      return (
        <SearchStepDialog
          open={open}
          onClose={handleClose}
          searchCode={searchCode}
          setSearchCode={setSearchCode}
          handleSearch={handleSearch}
          searchLoading={searchLoading}
          searchError={searchError}
          onBack={goToChoice}
        />
      );
    case SEARCH_RESULTS:
      return (
        <SearchResultsStepDialog
          open={open}
          onClose={handleClose}
          searchResults={searchResults}
          selectingAssetId={selectingAssetId}
          onSelectSearchAsset={handleSelectSearchAsset}
          onBack={goToSearch}
        />
      );
    default:
      return (
        <ChoiceStepDialog
          open={open}
          locationName={locationName}
          onClose={handleClose}
          onSearch={goToSearch}
          onNew={goToNew}
        />
      );
  }
}
